__turbopack_context__.v({
  "className": "public_sans_577b0429-module__fJ_M3W__className",
});
